<template>
    <!--个人资料-->
    <div class="personal_data">
        <ul class='title'>
            <li v-for="(item,index) in nav" :class="{active:curNav === index}" @click="
                    changeTab(index)">
                <span v-text="item.value"></span>
            </li>
        </ul>
        <div class="info">
            <!--个人资料 基本信息-->
            <form class="basic_info" action="" v-show="curNav === 0">
                <ul>
                    <li class='name'>
                        <input type="text" v-model="perInfo.name" placeholder="请输入您的姓名">
                    </li>
                    <li class='id_cart' :class="getId">
                        <input type="text" v-model="perInfo.idcard" placeholder='请输入你的身份证号码'>
                        <span>{{ mesIdCard }}</span>
                    </li>
                    <!--<li class='phone'>-->
                    <!--<input type="text" v-model="perInfo.phone" placeholder='电话号码'>-->
                    <!--</li>-->
                </ul>
                <div class="btn" @click="submitInfo()">保存修改</div>
            </form>
            <!--个人资料 修改手机-->
            <form class="modify_phone" v-show="curNav === 1">
                <ul>
                    <li class='phone'>
                        <input type="text" v-model="perInfo.phone" placeholder="旧手机号码" readonly>
                    </li>
                    <li class='phone' :class="getPhone">
                        <input type="text" v-model="newPhone" placeholder="请输入新手机号码">
                        <span>{{ msgphone }}</span>
                    </li>
                    <li class='code'>
                        <input type="text" v-model="phoneCode" placeholder='请输入验证码'>
                        <button type="button" @click="getNewCode()">{{ codeMsg }}</button>
                    </li>
                </ul>
                <div class="btn" @click="EditPhone()">保存修改</div>
            </form>
            <!--个人资料 修改密码-->
            <form class="modify_pwd" v-show="curNav === 2">
                <ul>
                    <li class='phone'>
                        <input type="text" v-model="perInfo.phone" placeholder="手机号码" readonly>
                    </li>
                    <li class='code'>
                        <input type="text" v-model="passCode" placeholder='请输入验证码'>
                        <button type="button" @click="getNewCode()">{{ codeMsg }}</button>
                    </li>
                    <li class='pwd'>
                        <input type="text" v-model="password" placeholder="请输入新密码">
                    </li>
                </ul>
                <div class="btn" @click="editPassword()">保存修改</div>

            </form>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
	import {
		getWeixinAcc,
		editWeixinAcc,
		getEditPhoneCode,
		editPhone,
		getEditPasswordCode,
		editPassword,
	} from '../../api/index'
	import { meInfo	} from '../../apiNew/index'

	export default {
		data() {
			return {
				tabView: 'select0',
				nav: [{value: '基本信息'}, {value: '修改手机'}, {value: '修改密码'}],
				curNav: 0,
				perInfo: {},
				phoneCode: '',
				passCode: '',
				password: '',
				newPhone: '',
				msgphone: '',
				mesIdCard: '',
				// 获取验证码按钮
				codeMsg: '获取验证码',
				ISFS: true, //是否发送  true 默认是可以发送
				YiFa: false,//已发的样式,
				token: '',
			};
		},
		components: {},
		mounted() {
			this.init()
			if (localStorage.getItem('isLogin') === '1') {
				this.token = localStorage.getItem('token')
				this.perInfo = JSON.parse(localStorage.getItem('userInfo'))
			}
		},
		created() {

			window.addEventListener('setItem', () => {
				// console.log(localStorage.getItem('isLogin')
				this.perInfo = JSON.parse(localStorage.getItem('userInfo'))
			})
			// console.log(this.perInfo)
		},
		methods: {
			init() {
			},
			//个人资料切换
			changeTab: function (index) {
				this.curNav = index
			},
			//修改个人信息
			submitInfo() {
				let idCardCheck = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
				console.log(this.perInfo.idcard)
				if (this.perInfo.idcard === '') {
					editWeixinAcc({
						name: this.perInfo.name,
						idcard: this.perInfo.idcard,
						token: this.token
					}).then(res => {
						this.$message({
							message: res.msg,
							type: 'success'
						})
						meInfo({
							token: localStorage.getItem('token')
						}).then(ress => {
							// console.log(ress)
							localStorage.setItem('isLogin', '1');
							localStorage.setItem('userInfo', JSON.stringify(ress.data));
						}).catch(err => {
							localStorage.setItem('isLogin', '0');
							this.$message({
								message: err.message,
								timeout: 1500,
							});
						})
						// getWeixinAcc({}).then(ress => {
						// 	// console.log(ress)
						// 	if (ress.code === 0) {
						// 		localStorage.setItem('userInfo', JSON.stringify(ress.data));
						// 	}
						// }).catch(err => {
						// 	this.$message({
						// 		message: err.msg,
						// 		type: 'warning'
						// 	})
						// })
						// console.log(res)
					}).catch(err => {
						this.$message({
							message: err.msg,
							type: 'warning'
						})
					})
				} else if (!idCardCheck.test(this.perInfo.idcard)) {
					this.mesIdCard = '请输入正确身份证号'
				} else {
					this.mesIdCard = '';
					editWeixinAcc({
						name: this.perInfo.name,
						idcard: this.perInfo.idcard,
						token: this.token
					}).then(res => {
						this.$message({
							message: res.msg,
							type: 'success'
						})
						meInfo({
							token: localStorage.getItem('token')
						}).then(ress => {
							// console.log(ress)
							localStorage.setItem('isLogin', '1');
							localStorage.setItem('userInfo', JSON.stringify(ress.data));
						}).catch(err => {
							localStorage.setItem('isLogin', '0');
							this.$message({
								message: err.message,
								timeout: 1500,
							});
						})
						// getWeixinAcc({}).then(ress => {
						// 	// console.log(ress)
						// 	if (ress.code === 0) {
						// 		localStorage.setItem('userInfo', JSON.stringify(ress.data));
						// 	}
						// }).catch(err => {
						// 	this.$message({
						// 		message: err.msg,
						// 		type: 'warning'
						// 	})
						// })
					}).catch(err => {
						this.$message({
							message: err.msg,
							type: 'warning'
						})
					})
				}
			},
			//获取验证码
			getNewCode() {
				if (this.ISFS === true) {
					this.codeTiming();
				} else {
					this.$message({
						message: '请稍后再试',
						type: 'warning'
					});
				}
			},
			// 获取验证码
			codeTiming() {
				let _this = this;
				//修改手机号
				if (this.curNav === 1) {
					let regTel = /^\d{11}$/g;
					if (this.newPhone === '') {
						this.msgphone = "手机号不能为空";
					} else if (!regTel.test(this.newPhone)) {
						this.msgphone = ('手机号格式不正确')
					} else {
						getEditPhoneCode({
							phone: this.newPhone
						}).then(result => {
							this.$message({
								message: result.msg,
								type: 'success'
							})
							_this.ISFS = false; //更改为不可以发送
							_this.YiFa = true;//更改为不可选的按钮
							if (result.code === 0) {
								let times = 60;
								let dinshiqi = setInterval(function () {
									times--;
									_this.codeMsg = times + "s" + "后重新获取";
									if (times < 1) {
										clearInterval(dinshiqi);
										_this.ISFS = true;
										_this.codeMsg = "获取验证码"
										_this.YiFa = false
									}
								}, 1000);
							}
							if (result.code === -1) {
								this.mesCode = result.msg
							}
						}).catch(err => {
							this.$message({
								message: err.msg,
								type: 'warning'
							})
						})
					}
				}
				//修改密码
				if (this.curNav === 2) {
					getEditPasswordCode({
						phone: this.perInfo.phone,
						token: this.token
					}).then(result => {
						// console.log(result);
						_this.ISFS = false; //更改为不可以发送
						_this.YiFa = true;//更改为不可选的按钮
						if (result.code === 0) {
							let times = 60;
							let dinshiqi = setInterval(function () {
								times--;
								_this.codeMsg = times + "s" + "后重新获取";
								if (times < 1) {
									clearInterval(dinshiqi);
									_this.ISFS = true;
									_this.codeMsg = "获取验证码"
									_this.YiFa = false
								}
							}, 1000);
						}
						if (result.code === -1) {
							this.mesCode = result.msg
						}
					}).catch(err => {
						this.$message({
							message: err.msg,
							type: 'warning'
						})
					})
				}
			},
			//修改手机号
			EditPhone() {
				editPhone({
					phone: this.newPhone,
					edit_phone_code: this.phoneCode,
					token: this.token
				}).then(res => {
					this.$message({
						message: res.msg,
						type: 'success'
					})
					this.codeMsg = ""
					meInfo({
						token: localStorage.getItem('token')
					}).then(ress => {
						// console.log(ress)
						localStorage.setItem('isLogin', '1');
						localStorage.setItem('userInfo', JSON.stringify(ress.data));
					}).catch(err => {
						localStorage.setItem('isLogin', '0');
						this.$message({
							message: err.message,
							timeout: 1500,
						});
					})
					// console.log(res)
				}).catch(err => {
					console.log(err)
				})
			},
			//修改密码
			editPassword() {
				editPassword({
					password: this.password,
					edit_password_code: this.passCode,
					token: this.token
				}).then(res => {
					// console.log(res)
					this.codeMsg = ""
					this.$message({
						message: res.msg,
						type: 'success'
					})
					meInfo({
						token: localStorage.getItem('token')
					}).then(ress => {
						// console.log(ress)
						localStorage.setItem('isLogin', '1');
						localStorage.setItem('userInfo', JSON.stringify(ress.data));
					}).catch(err => {
						localStorage.setItem('isLogin', '0');
						this.$message({
							message: err.message,
							timeout: 1500,
						});
					})
				}).catch(err => {
					console.log(err)
				})
			},
		},
		computed: {
			//新手机号不为空，去除提示
			getPhone() {
				if (this.newPhone !== '') {
					this.msgphone = ''
				}
			},
			getId() {
				if (this.perInfo.name !== '') {
					this.mesIdCard = ''
				}
			}
		}
	}
	;
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" rel="stylesheet/less" scoped>
    .personal_data {
        .title {
            display: flex;
            align-items: center;
            width: 100%;
            border-bottom: 1px solid #E6E6E6;
            li {
                width: 107px;
                text-align: center;
                font-size: 16px;
                color: #4d4d4d;
                margin-left: 37px;
                line-height: 40px;
                border-bottom: 2px solid transparent;
                cursor: pointer
            }
            li:first-child {
                margin-left: 0;
            }
            li.active {
                color: #FF5E5E;
                border-bottom: 2px solid #FF5E5E;
            }
        }
        .info {
            width: 440px;
            padding: 30px 40px 40px;
            margin-top: 40px;
            border: 1px solid #e6e6e6;
            .basic_info, .modify_phone, .modify_pwd {
                ul {
                    li {
                        position: relative;
                        margin-top: 15px;
                        border-bottom: 1px solid #E6E6E6;
                        input {
                            width: 100%;
                            color: #4d4d4d;
                            line-height: 42px;
                            border: none;
                            outline: none;
                        }
                        span {
                            position: absolute;
                            top: 100%;
                            left: 0;
                            font-size: 14px;
                            color: #FF5E5E;
                        }
                    }
                    li:first-child {
                        margin-top: 0;
                    }
                    .code {
                        position: relative;
                        button {
                            position: absolute;
                            right: 0;
                            bottom: 1px;
                            width: 120px;
                            height: 40px;
                            font-size: 14px;
                            color: #fff;
                            background: #50B3FF;
                            border: none;
                            border-radius: 2px;
                            cursor: pointer;
                        }
                    }
                }
                .btn {
                    width: 100%;
                    font-size: 14px;
                    color: #fff;
                    text-align: center;
                    background: #FF5E5E;
                    border-radius: 2px;
                    line-height: 44px;
                    margin: 40px 0 0;
                    cursor: pointer;
                }
            }
        }
    }
</style>